import { authGet, authPost, authPut } from '../auth/authFetches';
import axios from 'axios';

export async function fetchLawyer(accessToken: string, id: string) {
    const path = `/lawyerData/fetchLawyer/${encodeURIComponent(id)}`;
    return await authGet(accessToken, path);
}

export async function fetchLawyerImage(accessToken: string, id: string) {
    const path = `/lawyerData/lawyerImage/${encodeURIComponent(id)}`;
    const domain = import.meta.env.VITE_API_URL || '';
    const uri = domain + path;
    try {
        const response = await fetch(uri, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (!response.ok) {
            console.error('Failed to fetch image:', response.statusText);
            return null;
        }
        const blob = await response.blob();
        return blob;
    } catch (error) {
        console.error('Error fetching lawyer image:', error);
        return null;
    }
}

export async function updateImage(accessToken: string, id: string, image: File | null) {
    if (image) {
        const formData = new FormData();
        formData.append('imageFile', image as Blob);
        console.log(formData);
        const path = `/lawyerData/updateImage/${encodeURIComponent(id)}`;
        const domain = import.meta.env.VITE_API_URL || '';
        const uri = domain + path;
        try {
            const res = await fetch(uri, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });
            
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            
            // Check if response has content before parsing JSON
            if (res.status === 204 || res.headers.get('content-length') === '0') {
                return { success: true };
            }
            
            const message = await res.json();
            return message;
        } catch (err) {
            console.error(`Image update request for lawyer with id ${id} failed`);
            console.error(err);
            return;
        }
    } else {
        console.log('No image to update');
    }
}

export async function resummariseLawyer(accessToken: string, lawyerId: string) {
    const path = `/lawyerData/resummarise/${encodeURIComponent(lawyerId)}`;
    return await authGet(accessToken, path);
}

export async function deleteLawyerImage(accessToken: string, lawyerId: string) {
    const path = `/lawyerData/deleteImage/${lawyerId}`;
    const domain = import.meta.env.VITE_API_URL || '';
    const uri = domain + path;
    const response = await fetch(uri, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    if (!response.ok) {
        throw new Error('Failed to delete image');
    }
};

export async function updateLawyerField(accessToken: string, lawyerName: string, field: string, value: any) {
    const path = `/lawyerData/updateLawyer`;
    return await authPut(accessToken, path, {
        LawyerName: lawyerName,
        [field]: value
    });
}

export async function fetchLawyersTable(accessToken: string) {
    const path = `/lawyerData/fetchLawyersTable`;
    return await authGet(accessToken, path);
}

export const updateLawyerName = async (accessToken: string, oldName: string, newName: string) => {
  const API_BASE_URL = import.meta.env.VITE_API_URL || '';
  const config = {
    method: 'PUT',
    url: `${API_BASE_URL}/lawyerData/updateLawyerName/${encodeURIComponent(oldName)}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    data: { newName },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error('Error updating lawyer name:', error);
    throw error;
  }
};
